<template>
    <div id="innovation-footer">
      <div id="innovation-bar">
        <div class="innovation-top">
          <div class="innovation-status">
             <a href="https://www.asu.edu/rankings"><span>ASU is No.1 in the U.S. for innovation</span></a>
          </div>
          <div class="innovation-hidden d-none d-lg-block">
            <a href="https://www.asu.edu/rankings"><img src="//www.asu.edu/asuthemes/4.8/assets/ASU-number-1-innovation-best-colleges.png" alt="Best Colleges U.S. News Most Innovative 2019"></a>
          </div>
        </div>
      </div>
      <div class="footer-menu">
        <ul class="default d-flex flex-column d-md-table">
          <li><a href="https://www.asu.edu/copyright/">Copyright and Trademark</a></li>
          <li><a href="https://www.asu.edu/accessibility/">Accessibility</a></li>
          <li><a href="https://www.asu.edu/privacy/">Privacy</a></li>
          <li><a href="https://www.asu.edu/tou/">Terms of Use</a></li>
          <li><a href="https://www.asu.edu/asujobs">Jobs</a></li>
          <li><a href="https://www.asu.edu/emergency/">Emergency</a></li>
          <li class="no-border"><a href="https://www.asu.edu/contactasu/">Contact ASU</a></li>
        </ul>
      </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>
#innovation-footer{
  z-index: 5;
}
  @media only screen and (max-width: 767px) {
.innovation-status{
  width: 95% !important;
}
}
</style>